const countLabel = (value, singular, plural) => {
  const count = Number(value) || 0;
  return `${count} ${count === 1 ? singular : plural}`;
};

export const formatApiSyncRunSummary = (run) => {
  if (run?.status === 'Queued') return 'Waiting to start. No rows have been imported by this run yet.';

  const inserted = countLabel(run?.insertedCount, 'new row added', 'new rows added');
  const updated = countLabel(run?.updatedCount, 'existing row updated', 'existing rows updated');
  const rejected = countLabel(run?.rejectedCount, 'row rejected', 'rows rejected');

  if (run?.status === 'Running') return `Sync in progress. ${inserted}, ${updated}, and ${rejected}.`;

  const outcome = run?.status === 'CompletedWithWarnings'
    ? 'Sync completed with warnings.'
    : run?.status === 'CompletedWithErrors'
      ? 'Sync completed with errors.'
      : run?.status === 'Failed'
        ? 'Sync failed.'
        : 'Sync completed successfully.';

  return `${outcome} ${inserted}, ${updated}, and ${rejected}.`;
};
